<template>
  <div id="app" class="wrap">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>
<style lang="less">
* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}

html {
  height: 100%;

  body {
    height: 100%;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
      "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-size: 14px;
    line-height: 1;
    color: #333;
    overflow-y: scroll;

    .wrap {
      height: 100%;
    }
  }
}
</style>